import React, { useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

const errText = (d, f) => (typeof d === "string" ? d : f);

export default function AdminProfile() {
  const { user, refreshUser, logout } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [pw, setPw] = useState({ current_password: "", new_password: "", confirm: "" });
  const setP = (k) => (e) => setPw({ ...pw, [k]: e.target.value });

  const saveName = async (e) => {
    e.preventDefault();
    try { await api.put("/auth/profile", { name }); await refreshUser(); toast.success("Profile updated"); }
    catch (err) { toast.error(errText(err.response?.data?.detail, "Error")); }
  };
  const changePw = async (e) => {
    e.preventDefault();
    if (pw.new_password !== pw.confirm) return toast.error("Passwords do not match");
    try {
      await api.post("/auth/change-password", { current_password: pw.current_password, new_password: pw.new_password });
      toast.success("Password changed");
      setPw({ current_password: "", new_password: "", confirm: "" });
    } catch (err) { toast.error(errText(err.response?.data?.detail, "Error")); }
  };

  return (
    <div className="max-w-xl">
      <h2 className="font-serif text-3xl md:text-4xl mb-8">Profile</h2>

      <div className="border border-white/10 bg-[#0a0a0a] p-8 mb-6">
        <p className="text-xs uppercase tracking-widest text-gold mb-4">Account</p>
        <p className="text-white/40 text-sm">Email</p>
        <p className="text-white mb-5">{user?.email}</p>
        <form onSubmit={saveName} className="space-y-5" data-testid="profile-form">
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Full name" className="editorial-input" data-testid="profile-name" />
          <button className="bg-gold text-black text-xs uppercase tracking-widest px-6 py-2.5 hover:bg-white transition-colors" data-testid="profile-save">Save</button>
        </form>
      </div>

      <div className="border border-white/10 bg-[#0a0a0a] p-8 mb-6">
        <p className="text-xs uppercase tracking-widest text-gold mb-4">Change Password</p>
        <form onSubmit={changePw} className="space-y-5" data-testid="password-form">
          <input type="password" required placeholder="Current password" value={pw.current_password} onChange={setP("current_password")} className="editorial-input" data-testid="current-password" />
          <input type="password" required placeholder="New password" value={pw.new_password} onChange={setP("new_password")} className="editorial-input" data-testid="new-password" />
          <input type="password" required placeholder="Confirm new password" value={pw.confirm} onChange={setP("confirm")} className="editorial-input" data-testid="confirm-password" />
          <button className="bg-gold text-black text-xs uppercase tracking-widest px-6 py-2.5 hover:bg-white transition-colors" data-testid="change-password-btn">Update password</button>
        </form>
      </div>

      <button onClick={logout} data-testid="profile-logout" className="border border-white/20 text-white text-xs uppercase tracking-widest px-6 py-3 hover:border-red-400 hover:text-red-400 transition-colors">Log out</button>
    </div>
  );
}
